import { getAuthToken } from "./authService";
import api from "../api";

const API_BASE_URL = `${process.env.REACT_APP_API_URL || "http://localhost:3001"}/rooms`;

class RoomManageService {
  // Get room manage data
  async getRoomManageData(roomId) {
    try {
      const token = getAuthToken();
      const response = await fetch(`${API_BASE_URL}/${roomId}/manage`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Error fetching room manage data:", error);
      // Return mock data as fallback
      return this.getMockRoomManageData(roomId);
    }
  }

  // Search properties
  async searchProperties(searchTerm) {
    try {
      const token = getAuthToken();
      const response = await fetch(`${API_BASE_URL}/search-properties`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ search: searchTerm }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Error searching properties:", error);
      // Return mock data as fallback
      return this.getMockPropertySearch(searchTerm);
    }
  }

  // Move guardian
  async moveGuardian(formData) {
    try {
      const token = getAuthToken();
      const response = await fetch(`${API_BASE_URL}/manage`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(formData),
      });

      if (!response.ok) {
        const errorData = await response.json();
        return {
          success: false,
          message: errorData.message || 'Failed to move guardian',
          errors: errorData.errors || {}
        };
      }

      const data = await response.json();
      return {
        success: true,
        data
      };
    } catch (error) {
      console.error("Error moving guardian:", error);
      throw error;
    }
  }

  // Inject property for manage
  async injectProperty(roomId, propertyId, selectedGuardians) {
    try {
      const token = getAuthToken();
      const response = await fetch(`${API_BASE_URL}/${roomId}/manage/inject-property`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          propertyId,
          selectedGuardians
        }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Error injecting property:", error);
      throw error;
    }
  }

  // Mock data for fallback
  getMockRoomManageData(roomId) {
    return {
      success: true,
      data: {
        room: {
          id: parseInt(roomId),
          name: "Room 1",
          key_number: "K001",
          price: 500,
          property: {
            id: 1,
            name: "Sample Property",
            property_id: "PROP001"
          },
          assignedGuardiansRents: [
            {
              id: 1,
              license_fee: 500,
              damage_security_payment: 200,
              pay_gas: 1,
              pay_electric: 1,
              pay_water: 0,
              pay_council_tax: 0,
              room: {
                id: 1,
                name: "Room 1",
                price: 500
              },
              guardian: {
                id: 1,
                unique_guardian_number: "G001",
                full_name: "John Doe",
                status: {
                  name: "Active"
                },
                user: {
                  id: 1,
                  fullName: "John Doe",
                  mobile_number: "07123456789",
                  email: "john.doe@example.com",
                  image: null
                }
              },
              property: {
                id: 1,
                name: "Sample Property"
              }
            }
          ]
        },
        property: {
          id: 1,
          property_id: "PROP001",
          name: "Sample Property",
          address_1: "123 Sample Street",
          postcode: "SW1A 1AA",
          short_description: "A sample property for testing",
          photos: [],
          isActive: () => true
        },
        officers: [
          { id: 1, name: "Officer 1" },
          { id: 2, name: "Officer 2" }
        ],
        guardians: [1],
        moveGuardian: true,
        disabledRents: []
      }
    };
  }

  // Mock property search
  getMockPropertySearch(searchTerm) {
    return {
      success: true,
      data: {
        property: {
          id: 1,
          property_id: "PROP001",
          name: "Sample Property",
          address_1: "123 Sample Street",
          postcode: "SW1A 1AA",
          short_description: "A sample property for testing",
          photos: [],
          isActive: () => true
        },
        rooms: [
          {
            id: 1,
            name: "Room 1",
            key_number: "K001",
            isEmpty: () => false,
            canHaveGuardianAssigned: () => true,
            roomClass: "room-available",
            assignedGuardiansRents: []
          },
          {
            id: 2,
            name: "Room 2",
            key_number: "K002",
            isEmpty: () => true,
            canHaveGuardianAssigned: () => true,
            roomClass: "room-vacant",
            assignedGuardiansRents: []
          }
        ]
      }
    };
  }
}

export default new RoomManageService(); 